var _title, _title2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardStatusPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "190.351 208.973 230.271 160.541",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 190.351,
    y: 208.973,
    width: 230.271,
    height: 160.541,
    rx: 2,
    ry: 2,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, 526.00293, -143.878769)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Card")), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.22)"
    },
    x: -331.513,
    y: 381.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgb(236, 92, 12)",
      stroke: "rgb(175, 88, 17)"
    },
    x: -323.666,
    y: 374.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    x: -320.505,
    y: 399.616,
    width: 195.51,
    height: 27.321
  }), /*#__PURE__*/React.createElement("rect", {
    x: -306.89,
    y: 457.481,
    width: 63.758,
    height: 23.803,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(241, 180, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.125 463.301 L -161.852 463.291"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      strokeWidth: 8,
      strokeLinecap: "round",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.323 476.746 L -189.559 476.736"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.399759, 0, 0, 0.399759, 491.950531, 134.197876)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Status Pending")), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.19)"
    },
    cx: -257.82,
    cy: 265.405,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgb(248, 248, 248)",
      stroke: "rgb(238, 191, 0)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 7,
      fill: "rgba(255, 205, 7, 0.43)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 30.75,
    ry: 30.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M -247.389 292.52 C -245.159 292.224 -243.398 294.404 -244.154 296.523 C -244.548 297.597 -245.466 298.351 -246.604 298.502 C -249.223 298.839 -251.868 298.92 -254.503 298.741 C -264.223 298.087 -272.969 293.875 -279.448 287.396 C -286.512 280.332 -290.883 270.572 -290.883 259.793 C -290.883 249.012 -286.512 239.253 -279.448 232.188 C -272.383 225.123 -262.624 220.753 -251.844 220.753 C -248.106 220.753 -244.463 221.291 -240.991 222.294 C -238.143 223.116 -235.398 224.262 -232.812 225.71 L -233.582 223.695 C -234.223 222.006 -233.376 220.118 -231.69 219.473 C -230.001 218.832 -228.112 219.679 -227.468 221.368 L -224.216 229.878 C -224.093 230.201 -224.022 230.542 -224.005 230.888 C -223.749 232.474 -224.699 234.046 -226.279 234.525 L -234.99 237.19 C -236.714 237.713 -238.535 236.739 -239.058 235.016 C -239.58 233.294 -238.607 231.471 -236.884 230.949 L -236.167 230.73 C -238.232 229.613 -240.41 228.72 -242.666 228.068 C -245.553 227.235 -248.631 226.787 -251.844 226.787 C -260.957 226.787 -269.209 230.481 -275.182 236.455 C -281.154 242.426 -284.849 250.677 -284.849 259.793 C -284.849 268.907 -281.154 277.157 -275.182 283.13 C -269.769 288.543 -262.486 292.084 -254.384 292.7 C -252.067 292.876 -249.683 292.818 -247.389 292.52 Z M -236.878 289.295 C -239.306 290.538 -238.983 294.099 -236.366 294.881 C -235.609 295.096 -234.855 295.03 -234.149 294.677 C -232.203 293.7 -230.334 292.548 -228.582 291.254 C -227.726 290.617 -227.281 289.612 -227.373 288.55 C -227.607 286.204 -230.278 285.015 -232.176 286.408 C -233.658 287.502 -235.231 288.468 -236.878 289.295 Z M -224.571 278.482 C -225.944 280.531 -224.401 283.286 -221.932 283.177 C -220.967 283.126 -220.102 282.653 -219.561 281.844 C -218.339 280.032 -217.284 278.134 -216.379 276.143 C -215.506 274.178 -216.865 271.977 -219.015 271.885 C -220.248 271.845 -221.365 272.533 -221.878 273.658 C -222.644 275.345 -223.535 276.946 -224.571 278.482 Z M -219.026 263.01 C -219.135 264.194 -218.56 265.304 -217.535 265.906 C -215.613 266.997 -213.244 265.775 -213.018 263.578 C -212.812 261.399 -212.779 259.24 -212.928 257.056 C -213.003 256.007 -213.61 255.082 -214.542 254.592 C -216.635 253.507 -219.115 255.13 -218.949 257.479 C -218.821 259.332 -218.851 261.159 -219.026 263.01 Z M -221.526 246.781 C -220.85 248.34 -219.036 249.041 -217.491 248.33 C -216.004 247.646 -215.336 245.903 -215.982 244.398 C -216.837 242.394 -217.866 240.467 -219.043 238.633 C -220.522 236.359 -224.001 237.022 -224.539 239.682 C -224.687 240.464 -224.547 241.228 -224.116 241.901 C -223.118 243.459 -222.251 245.079 -221.526 246.781 Z",
    style: {
      fill: "rgb(238, 191, 0)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(238, 191, 0)"
    },
    cx: -251.795,
    cy: 259.692,
    rx: 3.776,
    ry: 3.776
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(238, 191, 0)"
    },
    cx: -237.986,
    cy: 259.692,
    rx: 3.776,
    ry: 3.776
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(238, 191, 0)"
    },
    cx: -264.854,
    cy: 259.692,
    rx: 3.776,
    ry: 3.776
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardStatusPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-status-pending.a5e071113e10bb7341af8611b9111f74.svg";